export type LicenseProduct = {
  product_name: string
  description: string
  product_category: 'license' | 'streams' | 'vlm agents' | 'vlm streams'
  unit_price: number
  price_currency: string
  billing_period: 'monthly' | 'yearly'
  number_of_streams: number
  number_of_users: number
  number_of_apps: number
  extra_camera_stream_per_month_eur: number
  model_trainings_per_month: number
  version_control_models: number
  free_test_images_per_month: number
  fast_training: boolean
  event_storage_gb: number
  model_test_data_per_month_gb: number
  dataset_storage_gb: number
  event_retention_months: number
  custom_api_access: boolean
  labeling_service: boolean
  labeling_price_per_bounding_box_eur: number
}

export enum SubscriptionStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Suspended = 'Suspended',
  Upgraded = 'Upgraded'
}

export type Subscription = {
  user: {
    first_name: string
    last_name: string
    email: string
  }
  ordered_items: {
    product: LicenseProduct
    quantity: number
    created_at: string
    updated_at: string
  }[]
  status: SubscriptionStatus
  start_date: string
  end_date: string
  extra_streams: number
  created_at: string
  updated_at: string
}

export type FeatureKey =
  | 'number_of_streams'
  | 'number_of_users'
  | 'number_of_apps'
  | 'model_trainings'
  | 'model_test_data'
  | 'user_ml_models'
  | 'event_storage'
  | 'dataset_storage'
  | 'vlm_agents'

type ApiFeatureUsage = {
  used: number
  limit: number
  unit: 'count' | 'gb'
  period: 'monthly' | null
}

export type ApiFeatureUsageSummary = {
  [feature in FeatureKey]: ApiFeatureUsage
}

export type FeatureUsage = ApiFeatureUsage & {
  remaining: number
  isUnlimited: boolean
}

export type FeatureUsageSummary = {
  [feature in FeatureKey]: FeatureUsage
}
